
import { flags } from "@/feature-flags";
import { Options, prop, Vue } from "vue-class-component";
import { MainAppController } from "../../controllers/MainAppController";
import BreadcrumbV2 from "../breadcrumb-v2/index.vue";
import updateFeatureName from "@/app/infrastructures/misc/common-library/UpdateFeatureName";
import { FlagsSidebar } from "@/feature-flags/flags-sidebar";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";

class Prop {
  customBreadcrumbTitle = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  components: {
    BreadcrumbV2
  }
})
class Breadcrumb extends Vue.with(Prop) {
  get getCurrentRoute(): any {
    return this.$route;
  }
  get id() {
    if (!this.$route.meta.customPath) {
      return this.$route.params.id;
    }

    const title = this.$route.meta.title as string;
    if (title && typeof title === "string") {
      const translatedTitle = this.$t(title);
      if (translatedTitle !== title) {
        return translatedTitle;
      }
    }

    return this.$route.meta.name;
  }
  get params() {
    return this.$route.query;
  }

  get isGrayBreadcrumb() {
    return (
      this.$route.name === "kulioner-detail" ||
      this.$route.name === "kulioner-list"
    );
  }

  get isSemiboldBreadcrumb() {
    return [
      "pusat-resolusi-v2-list",
      "ticket_escalate",
      "my_ticket",
      "ticket_followed"
    ].includes(this.$route.name as string);
  }

  get decideBreadcrumbColor() {
    if (this.isGrayBreadcrumb) {
      return "text-gray-lp-500 font-semibold text-sm";
    }

    return "text-red-lp-100";
  }

  goHome() {
    this.$router.push(flags.flag_default_path_genesis.getValue());
  }
  goPath(path: any) {
    this.$router.push(path);
  }
  goDetail(path: any, id: string) {
    const detail = id && path.replace(":id", id);
    this.$router.push(detail);
  }

  get permissionSidebarV2Enabled() {
    return FlagsSidebar.permission_sidebar_v2_enabled.isEnabled();
  }

  get isSidebarAndBreadcrumbV2() {
    return (
      MainAppController.isSidebarAndBreadcrumbV2 &&
      this.permissionSidebarV2Enabled &&
      !IS_SENDER_ACCOUNT
    );
  }
  nameUpdateFeature(name: any) {
    return updateFeatureName(name);
  }
  translatedFeatureName(name: any) {
    if (name && typeof name === "string" && name.includes(".")) {
      const direct = this.$t(name);
      if (direct !== name) return direct;
    }
    const displayName = updateFeatureName(name);
    const key = "featureName." + displayName;
    const t = this.$t(key);
    return t === key ? displayName : t;
  }

  get isDashboardDetail() {
    return this.$route.name === "dashboard-detail";
  }
}
export default Breadcrumb
